import { models } from '@tfo/common'
import * as React from 'react'
import { observer } from 'mobx-react'
import ReportsItemDate from './ReportsItemDate'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import '../ReportsItem.scss'

export interface ReportsItemProps {
	data: models.IGroupOrder
	onClick: any
	reportPackages: models.ReportPackage[]
	showCompanyName: boolean
}

const ReportsItemArchived = ({
	data,
	intl,
	onClick,
	reportPackages,
	showCompanyName,
}: ReportsItemProps & WrappedComponentProps) => (
	<div
		className={'ReportsItem ReportsItem--archived ReportsItem--active'}
		id={'reportsItem_' + data.id.toString()}
		data-cy="archived-order">
		<div className={'ReportsItem__Inner'} onClick={onClick}>
			{showCompanyName && (
				<div className={'ReportsItem__Cell'}>{data.orders[0].companyName}</div>
			)}

			<div className={'ReportsItem__Cell'}>
				{reportPackages.find(x => x.id === data.orders[0].servicePackageId)
					?.customName ?? ''}
			</div>
			<div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}>
				{data.orders[0].receiptNumber}
			</div>
			<ReportsItemDate
				date={data.orders[0].created}
				label={intl.formatMessage({ id: 'common.ordered' })}
			/>
			<ReportsItemDate
				date={data.orders[0].delivered}
				label={intl.formatMessage({ id: 'common.delivered' })}
			/>
		</div>
	</div>
)
export default injectIntl(observer(ReportsItemArchived))
